// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"d65e6573","380":"47b87bfe","514":"a74c87d0","542":"d65e6573","580":"3e0be7e5","873":"a71f85e1","907":"78ac4ba3","956":"d5d3eadc"}[chunkId] + ".chunk.js";
};